import { useState } from "react";
import { ValidationResult } from "sprint-common-web";

import { useAssociateHistory } from "../../../quality-control/useAssociateHistory";
import { useMapToSubmissionsHistoryContent } from "../buttons/lookups/lookup-history/mapToSubmissionsHistoryContent";
import { ContentAssociationFormState } from "../types/ContentAssociationFormState";
import { useAssociateFormContentReferenceMapper } from "./useAssociateFormContentReferenceMapper";

export const useAssociateContentStandaloneForm = () => {
    const [validationResult, setValidationResult] = useState<ValidationResult>();

    const { mapFormStateToContentReference } = useAssociateFormContentReferenceMapper();

    const { mapToSubmissionsHistoryContent } = useMapToSubmissionsHistoryContent();

    const associateHistory = useAssociateHistory();

    const saveToHistory = async (formState: ContentAssociationFormState) => {
        const historyContent = await mapToSubmissionsHistoryContent(formState);

        if (historyContent) {
            associateHistory.save(historyContent);
        }
    };

    return {
        mapFormStateToContentReference,
        saveToHistory,
        validationResult,
        setValidationResult
    };
};
